import React from "react";

export default function MiniLoader({
  size = 20,
  className = "",
}) {
  return (
    // <span
    //   aria-label="Loading"
    //   role="status"
    //   className={`inline-block align-middle ${className}`}
    //   style={{ width: size, height: size }}
    // >
    //   <span
    //     className="block h-full w-full rounded-full border-2 border-[seagreen]/30 border-t-[seagreen] animate-spin"
    //   />
    // </span>
    <div className="flex justify-center items-center mt-6 h-40">
    <div className="relative">
      {/* Outer Ring */}
      <div className="w-12 h-12 border-4 border-seagreen border-t-transparent border-solid rounded-full animate-spin"></div>
      {/* Inner Pulse */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-3 h-3 bg-seagreen rounded-full animate-ping"></div>
      </div>
    </div>
  </div>
  );
}
